export default function Stat_Variance() {
  return <div>Stat_Variance Component</div>;
}
